import { useHistory } from 'react-router-dom'

const Page = ({ children }) => {
	const history = useHistory()

	const savedUser = localStorage.getItem('user')
	const savedUserObj = JSON.parse(savedUser)

	return (
		<div className='page'>
			<div className='page-inner'>
				{savedUserObj?._id ? children : history.push('/login')}
			</div>
		</div>
	)
}

export default Page
